import React from 'react';
import { ButtonGroup, ListGroup, FormControl, Button, Form } from 'react-bootstrap';
import { ReactSortable } from 'react-sortablejs';
import * as Yup from 'yup';
import { Formik } from 'formik';

import CustomModal from '../custom_modal/CustomModal';

import './dynacmicList.css';

const DynamicList = ({ sortableState, 
                       setSortableState, 
                       editingIndex,
                       editingValue,
                       setEditingValue, 
                       onAddItemList, 
                       onEditItemList, 
                       onBlur, 
                       onKeyPress,
                       onDeleteItemList,
                       formValues,
                       showSetScoreButton,
                       type }) => {
  const [showModalRows, setShowModalRows] = React.useState(0);
  const [showModalColumn, setShowModalColumn] = React.useState(0);
  const [index, setIndex] = React.useState(0);
  const [scoreError, setScoreError] = React.useState('');

  const handleClose = () => {
    setShowModalRows(false);
  }

  const handleCloseColumn = () => {
    setShowModalColumn(false);
  }

  const onShowModal = (ind) => {
    if (type === 'rows') {
      setShowModalRows(true);
    }else {
      setShowModalColumn(true);
    }
    setIndex(ind);
  }

  const onSubmit = (values) => {
    const state = sortableState.slice();
    if (type === 'rows') {
      const sortableStateTotalScore = state.reduce((acc, item, i) => i !== index ? acc + parseFloat(item.score) : acc, 0);
      setScoreError('');
      if (parseFloat(sortableStateTotalScore) + parseFloat(values.score) > parseFloat(formValues?.score)) {
        setScoreError('La suma de los puntajes no puede ser mayor al puntaje total de la pregunta');
        return;
      }
      state[index].score = values.score;
      setSortableState(state);
      setShowModalRows(false);
    }else{
      // state.forEach((item, i) => {
      //   state[i].score = 0;
      // });
      state[index].score = parseInt(values.isTheCorrectColumn) === 1 ? 1 : 0;
      setSortableState(state);
      setShowModalColumn(false);
    }
  }

  const schemaRows = Yup.object().shape({
    score: Yup.number().min(0, 'La cantidad mínima debe ser igual a 0').max(parseInt(formValues?.score) || 1, `La cantidad mínima debe ser ${parseInt(formValues?.score) || 1}`).required('El puntaje es requerido'),
  });

  const schemaColumns = Yup.object().shape({
    isTheCorrectColumn: Yup.boolean().required('El campo es requerido'),
  });

  return (
    <>
      <ReactSortable tag={ListGroup} variant="flush" className="mt-3 list-group-flush" list={sortableState} setList={setSortableState} >
        {sortableState.map((item, index) => (
          <ListGroup.Item 
            key={index}
            className="d-flex align-items-center p-0"
            onClick={() => onEditItemList(index, item)}>
              <i className="material-icons">drag_indicator</i>
              <div className="d-flex justify-content-between align-items-center flex-grow-1 ml-2">
                {editingIndex === index ? (
                  <FormControl
                    type="text"
                    className="dynamic-list-form-control"
                    autoFocus
                    autoComplete="off"
                    onBlur={onBlur}
                    value={editingValue}
                    onChange={(e) => setEditingValue(e.target.value)}
                    onKeyPress={onKeyPress} />
                ) : (
                  <p className="m-o">{item.description} {item?.score && item?.score > 0 && type === 'rows' ? `(${item?.score}) ptos` : ''}</p>
                )}
                <ButtonGroup>
                  <Button variant="link" onClick={() => onDeleteItemList(index)}>
                    <i className="material-icons">delete</i>
                  </Button>
                  {
                    showSetScoreButton && type === 'rows' && (
                      <Button variant="link" onClick={() => onShowModal(index)}>
                        <i className="material-icons">score</i>
                      </Button>
                    )
                  }
                </ButtonGroup>
              </div>
          </ListGroup.Item>
        ))}
      </ReactSortable>
      <Button variant="link" className="p-0 ml-4" onClick={() => onAddItemList(sortableState)}>Agregar</Button>
      <Formik initialValues={{
          score: sortableState[index]?.score || 0,
        }} validationSchema={schemaRows} 
            onSubmit={onSubmit}
            enableReinitialize>
          {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
        }) => (
        <CustomModal 
          show={showModalRows}
          handleClose={handleClose}
          handleSave={handleSubmit}
          title="Asignar puntaje"
          size="sm"
          isForm={true}
          isSaving={false}>
           <Form.Group>
            <Form.Label className="ml-2">Puntaje</Form.Label>
            <Form.Control 
              className="rounded-pill"
              type="number" 
              name="score" 
              placeholder="Puntaje"
              isInvalid={(touched.score && errors.score) || scoreError}
              value={values.score} 
              onChange={handleChange} 
              onBlur={handleBlur} />
            <Form.Control.Feedback className="ml-2" type="invalid">
              {errors.score || scoreError}
            </Form.Control.Feedback>
           </Form.Group>
        </CustomModal>
      )}
      </Formik>
      <Formik initialValues={{
          isTheCorrectColumn: sortableState[index]?.score === 1 ? 1 : 0,
        }} validationSchema={schemaColumns} 
            onSubmit={onSubmit}
            enableReinitialize>
          {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          touched,
        }) => (
        <CustomModal 
          show={showModalColumn}
          handleClose={handleCloseColumn}
          handleSave={handleSubmit}
          title="Seleccionar columna correcta"
          size="sm"
          isForm={true}
          isSaving={false}>
           {/* <Form.Group>
            <Form.Label className="ml-2">¿Es columna correcta para la respuesta?</Form.Label>
            <Form.Select
              name="isTheCorrectColumn"
              value={values.isTheCorrectColumn}
              onChange={handleChange}
              isInvalid={errors.isTheCorrectColumn}>
              <option value={1}>Sí</option>
              <option value={0}>No</option>
            </Form.Select>
            <Form.Control.Feedback className="ml-2" type="invalid">
              {errors.isTheCorrectColumn}
            </Form.Control.Feedback>
           </Form.Group> */}
          <Form.Group>
            <Form.Label className="ml-2">¿Es columna correcta para la respuesta?</Form.Label>
            <Form.Control 
              className="rounded-pill"
              as="select"
              name="isTheCorrectColumn" 
              placeholder="Elija una opción"
              isInvalid={(touched.isTheCorrectColumn && errors.isTheCorrectColumn) || scoreError}
              value={values.isTheCorrectColumn} 
              onChange={handleChange} 
              onBlur={handleBlur}>
                <option value={1}>Sí</option>
                <option value={0}>No</option>
              </Form.Control>
            <Form.Control.Feedback className="ml-2" type="invalid">
              {errors.isTheCorrectColumn}
            </Form.Control.Feedback>
           </Form.Group>
        </CustomModal>
      )}
      </Formik>
    </>
  )
}

export default DynamicList;